export interface HasEstimates {
  normalizedEstimate(): any;
}

export function HasEstimates(originalClass: any): any {
  return class extends originalClass implements HasEstimates {
    get normalizedEstimate() {
      if (this.teamWorkflowStatus) {
        if (this.teamWorkflowStatus.isCompleted) {
          return this.originalEstimate;
        } else {
          return this.remainingEstimate;
        }
      }

      if (this.workflowStatus?.isCompleted) {
        return this.originalEstimate;
      } else {
        return this.remainingEstimate;
      }
    }
  };
}
